import React from "react";
import { Tooltip as AntToolTip } from "antd";

const Tooltip = ({ children, ...rest }) => <AntToolTip {...rest}>{children}</AntToolTip>;

export default Tooltip;
